import { useEffect, useState } from "react";
import { EXTRA_SIZES, LABEL_SIZES, isRoll29 } from "@/lib/labels";

const same = (a, b) => a.w === b.w && a.h === b.h;
const clamp = (v, lo, hi) => Math.min(Math.max(Number(v) || lo, lo), hi);
const chip = (on) => `rounded-full border px-4 py-2 text-sm transition-colors ${on ? "border-[#D4AF37] bg-[#D4AF37] text-[#0D0A0B]" : "border-[#2E252A] text-[#A89F91] hover:border-[#D4AF37]"}`;

const OtherSizes = ({ size, onChange }) => {
  const [custom, setCustom] = useState({ w: size.w, h: size.h });
  useEffect(() => {
    setCustom({ w: size.w, h: size.h });
  }, [size]);
  const isPreset = EXTRA_SIZES.some((s) => same(s, size));
  const apply = () => onChange({ w: clamp(custom.w, 20, 120), h: clamp(custom.h, 10, 100) });
  return (
    <details className="mt-4" open={!isRoll29(size)} data-testid="label-size-other">
      <summary className="cursor-pointer text-sm text-[#A89F91] hover:text-[#D4AF37]" data-testid="label-size-other-toggle">Other label sizes</summary>
      <div className="flex flex-wrap items-center gap-2 mt-3">
        {EXTRA_SIZES.map((s) => (
          <button key={`${s.w}x${s.h}`} onClick={() => onChange({ w: s.w, h: s.h })} className={chip(same(s, size))} title={s.note} data-testid={`label-size-${s.w}x${s.h}-extra`}>
            {s.w} × {s.h} mm
          </button>
        ))}
        <div className={`flex items-center gap-1 rounded-full border px-3 py-1 text-sm ${isPreset || isRoll29(size) ? "border-[#2E252A]" : "border-[#D4AF37]"}`}>
          <span className="text-[#A89F91] mr-1">Other</span>
          <input type="number" min={20} max={120} value={custom.w} onChange={(e) => setCustom({ ...custom, w: e.target.value })}
            className="w-14 bg-transparent text-[#F5F0EB] text-center outline-none" data-testid="label-size-custom-width" aria-label="Width in mm" />
          <span className="text-[#6E665D]">×</span>
          <input type="number" min={10} max={100} value={custom.h} onChange={(e) => setCustom({ ...custom, h: e.target.value })}
            className="w-14 bg-transparent text-[#F5F0EB] text-center outline-none" data-testid="label-size-custom-height" aria-label="Height in mm" />
          <span className="text-[#6E665D]">mm</span>
          <button onClick={apply} className="ml-1 text-[#D4AF37] hover:underline" data-testid="label-size-custom-apply">Use</button>
        </div>
      </div>
    </details>
  );
};

export const LabelSizePicker = ({ size, onChange }) => (
  <div className="max-w-5xl mx-auto px-6 mb-6" data-testid="label-size-picker">
    <p className="text-xs uppercase tracking-[0.2em] text-[#6E665D] mb-2">Label length · 29 mm roll</p>
    <div className="flex flex-wrap items-center gap-2">
      {LABEL_SIZES.map((s) => (
        <button key={s.w} onClick={() => onChange({ w: s.w, h: s.h })} className={chip(same(s, size))} data-testid={`label-size-${s.w}x${s.h}`}>
          {s.w} mm
        </button>
      ))}
    </div>
    <OtherSizes size={size} onChange={onChange} />
  </div>
);
